const _ = require('lodash');

const PagedList = require('../entities/paged-list');

const fields = [`name`, `propertyId`];
const TYPE_NAMES = {
  business: 'business',
  location: 'location',
  offer: 'offer',
  collection: 'collection',
  plan: 'plan',
  integration: 'integration'
};

const getPath = propertyId => `/properties/${propertyId}/tags`;

const parse = tag => tag.name;

class TagsRepo {
  /*:: static TYPE_NAMES: Object */
  constructor(client
  /*: ApiClient*/
  ) {
    this.client = client;
    this.TYPE_NAMES = TYPE_NAMES;
  }

  list(propertyId
  /*: string*/
  , typeName
  /*: string*/
  , modelId
  /*: string*/
  )
  /*: Promise<PagedList<string>>*/
  {
    const req = new this.client.Request(`${getPath(propertyId)}/list`, {
      typeName,
      modelId
    }, fields);
    req.parse = parse;
    return this.client.get(req);
  }

  create(propertyId
  /*: string*/
  , typeName
  /*: string*/
  , modelId
  /*: string*/
  , tagName
  /*: string*/
  )
  /*: Promise<any>*/
  {
    const req = new this.client.Request(`${getPath(propertyId)}/create`, {
      typeName,
      modelId,
      tagName
    }, []);
    return this.client.post(req);
  }

  delete(propertyId
  /*: string*/
  , typeName
  /*: string*/
  , modelId
  /*: string*/
  , tagName
  /*: string*/
  )
  /*: Promise<any>*/
  {
    const req = new this.client.Request(`${getPath(propertyId)}/delete`, {
      typeName,
      modelId,
      tagName
    }, []);
    return this.client.post(req);
  }

  reconcile(propertyId
  /*: string*/
  , typeName
  /*: string*/
  , modelId
  /*: string*/
  , tags
  /*: Array<string>*/
  ) {
    return this.list(propertyId, typeName, modelId).then(persistedTags => persistedTags.items).then(persistedTags => {
      const toAdd = _.difference(tags, persistedTags);

      const toRemove = _.difference(persistedTags, tags);

      const addProcess = Promise.all(toAdd.map(newTag => this.create(propertyId, typeName, modelId, newTag)));
      const removeProcess = Promise.all(toRemove.map(oldTag => this.delete(propertyId, typeName, modelId, oldTag)));
      return Promise.all([addProcess, removeProcess]);
    });
  }

}

TagsRepo.TYPE_NAMES = TYPE_NAMES;
module.exports = TagsRepo;